import { Component, ElementRef, inject, viewChild, ViewEncapsulation } from '@angular/core';
import { DragHandleComponent } from "../../../../../../../../shared/drag-handle/drag-handle.component";
import { TranslateModule } from '@ngx-translate/core';
import { SignPaymentCardComponent } from './components/sign-payment-card/sign-payment-card.component';
import { LoggedPaymentCardComponent } from "./components/logged-payment-card/logged-payment-card.component";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-make-payment',
  standalone: true,
  imports: [
    TranslateModule,
    DragHandleComponent,
    SignPaymentCardComponent,
    LoggedPaymentCardComponent
],
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MakePaymentComponent {
  public makePaymentRef = viewChild<ElementRef>('makePaymentRef');
    
  private sanitizer = inject(DomSanitizer);
  public urlIframe: SafeResourceUrl;

  // TODO: SIMULATE USER LOGIN
  public userLoggedIn = true;

  ngOnInit(){
    const token = `k9yg9qL5AAaq/DgEIeHbRhByG2fVg2+K1wxoEKxxb6KLKvEs5hzKlD36vdxCz338F1DjcC9J9sgOcMQBTM+57TAd4QXaqrRykL/AwCToRjb3yv0WAUzbkOnh9nDcDDTs7RGWdLeBs16jau1Bl1meDnfxFkhxwDH0wIExpp6+oUJdnNnUndMlDTVXfFgk3T9c`;
    const url = `https://mpass.mobi/p360/?token=${token}&appDestination=marketplace#/marketplace`;
    this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
